import { Box, Typography, useTheme } from "@mui/material";
import { StyledMessagePoppup } from "./MessagePoppup.styled";
import { useEffect, useState } from "react";
import { useTextFormatter } from "../../hooks/useTextFormatter";

type MessagePoppupProps = {
  text: string[];
  statusCode: number;
  closeMessage: () => void;
};

export const MessagePoppup = ({
  text,
  statusCode,
  closeMessage,
}: MessagePoppupProps) => {
  const theme = useTheme();
  const [background, setBackground] = useState<string>(
    theme.palette.success.main
  );
  const [responseText, setResponseText] = useState<string>("");
  const { renderText } = useTextFormatter();

  useEffect(() => {
    switch (statusCode) {
      case 201: {
        setBackground(theme.palette.success.main);
        setResponseText(text[0]);
        break;
      }
      default: {
        setBackground(theme.palette.error.main);
        setResponseText(text[1]);
      }
    }

    setTimeout(() => {
      closeMessage();
    }, 10 * 1000);
  }, []);

  return (
    <StyledMessagePoppup theme={theme} background={background}>
      <Box className="content">
        <Typography>{renderText(responseText)}</Typography>
      </Box>
    </StyledMessagePoppup>
  );
};
